import * as echarts from 'echarts/core';
import lightThemeJson from './light-theme.json';
import darkThemeJson from './dark-theme.json';
import { BarChart, LineChart as ELineChart, ScatterChart } from 'echarts/charts';

import { CanvasRenderer } from 'echarts/renderers';

import {
	TitleComponent,
	TooltipComponent,
	LegendComponent,
	GridComponent,
	ToolboxComponent,
	DatasetComponent,
	DataZoomComponent
} from 'echarts/components';

echarts.use([
	DataZoomComponent,
	TitleComponent,
	TooltipComponent,
	LegendComponent,
	GridComponent,
	ToolboxComponent,
	DatasetComponent,
	ELineChart,
	ScatterChart,
	BarChart,
	CanvasRenderer
]);

echarts.registerTheme('light', lightThemeJson);
echarts.registerTheme('dark', darkThemeJson);

export default echarts;
